import React, { useState, useEffect } from 'react';
import './TrustStrip.css';

const TrustStrip = ({ className = '' }) => {
  const [strategyCount, setStrategyCount] = useState(3247); // Starting count
  const [isVisible, setIsVisible] = useState(false);

  // Simulate live counter increment (every 8-15 seconds)
  useEffect(() => {
    const incrementInterval = setInterval(() => {
      setStrategyCount(prev => prev + Math.floor(Math.random() * 3) + 1); // Add 1-3 strategies
    }, Math.random() * 7000 + 8000); // 8-15 seconds

    // Fade in animation
    const fadeInTimer = setTimeout(() => setIsVisible(true), 300);

    return () => {
      clearInterval(incrementInterval);
      clearTimeout(fadeInTimer);
    };
  }, []);

  return (
    <div className={`trust-strip-hero ${className} ${isVisible ? 'trust-strip-visible' : ''}`}>
      <div className="trust-strip-content-hero">
        
        {/* Trustpilot Rating - More Prominent */}
        <div className="trust-item-hero trust-rating-hero">
          <div className="trust-stars-hero">
            ⭐⭐⭐⭐⭐
          </div>
          <span className="trust-score-hero">4.6/5 Trustpilot</span>
        </div>

        {/* Live Strategy Counter - More Prominent */}
        <div className="trust-item-hero trust-counter-hero">
          <span className="trust-number-hero">
            {strategyCount.toLocaleString()}+
          </span>
          <span className="trust-label-hero">strategies built</span>
          <div className="trust-pulse-hero"></div>
        </div>

      </div>
    </div>
  );
};

export default TrustStrip; 